import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import postBusinessProfile from '../apis/postBusinessProfile';
import putBusinessProfile from '../apis/putBusinessProfile';
import { updateUser } from '../store/slices/authSlice';

const defaultData = {
    first_name: '',
    last_name: '',
};

const notify = (msg) => toast(msg);

const EditViewForm = ({ mode = 'view', initialData = {}, onSubmit }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState(defaultData);

    useEffect(() => {
        if (mode !== 'create' && initialData) setFormData({ ...defaultData, ...initialData });
    }, [initialData, mode]);

    const isReadOnly = mode === 'view';

    const handleChange = (e) => {
        if (isReadOnly) return;
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (onSubmit) onSubmit(formData);

        if (initialData) {
            try {
                const { user } = await putBusinessProfile(formData);
                console.log({ user });
                dispatch(updateUser(user));
                notify('Profile updated!');
            } catch (e) {
                console.error(e);
                notify('oops, some error happened!');
            }
        } else {
            try {
                await postBusinessProfile(formData);
                notify('Profile created!');
            } catch (e) {
                console.error(e);
                notify('oops, some error happened!');
            }
        }
    };

    const renderField = (label, name, type = 'text', rows = 1, column = 12) => (
        <div className={`mb-3 col-md-${column}`}>
            <label className="form-label">{label}</label>
            {rows > 1 ? (
                <textarea
                    className="form-control"
                    name={name}
                    rows={rows}
                    value={formData[name]}
                    onChange={handleChange}
                    readOnly={isReadOnly}
                />
            ) : (
                <input
                    type={type}
                    className="form-control"
                    name={name}
                    value={formData[name]}
                    onChange={handleChange}
                    readOnly={isReadOnly}
                />
            )}
        </div>
    );

    return (
        <div className="">
            <div className="border-none mt-4">
                <div className="bg-none">
                    <form onSubmit={handleSubmit} className="p-4 rounded shadow-sm  bg-light-gradient my-3">
                        <h5 className="mb-4 text-capitalize"> Profile</h5>
                        <div className="row px-4">
                            {renderField('First Name', 'first_name', 'text', 1, 6)}
                            {renderField('Last Name', 'last_name', 'text', 1, 6)}

                            <ToastContainer />

                            <div className="">
                                {!isReadOnly && (
                                    <button type="submit" className="btn mt-3 fw-semibold btn-primary-gradient text-white">
                                        {mode === 'edit' ? 'Update' : 'Create'} <i className="bi bi-save"></i>
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {/* Password Update Card */}
            <PasswordUpdateCard />
        </div>
    );
};

// Password update card component
const PasswordUpdateCard = () => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        if (!currentPassword || !newPassword || !confirmPassword) {
            notify('Please fill all password fields.');
            return;
        }
        if (newPassword !== confirmPassword) {
            notify('New passwords do not match.');
            return;
        }
        setLoading(true);
        try {
            // TODO: Replace with your actual API call for password update
            // await updatePasswordApi({ currentPassword, newPassword });
            setTimeout(() => {
                setLoading(false);
                notify('Password updated successfully!');
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            }, 1000);
        } catch (e) {
            setLoading(false);
            notify('Failed to update password.');
        }
    };

    return (
        <div className="border-none mt-4">
            <div className="bg-none">
                <form onSubmit={handlePasswordUpdate} className="p-4 rounded shadow-sm bg-light-gradient my-3">
                    <h5 className="mb-4">Update Password</h5>
                    <div className="row px-4">
                        <div className="mb-3 col-md-12">
                            <label className="form-label">Current Password</label>
                            <input
                                type="password"
                                className="form-control"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3 col-md-6">
                            <label className="form-label">New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3 col-md-6">
                            <label className="form-label">Confirm New Password</label>
                            <input
                                type="password"
                                className="form-control"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                        </div>
                        <ToastContainer />
                        <div className="">
                            <button
                                type="submit"
                                className="btn mt-3 fw-semibold btn-primary-gradient text-white"
                                disabled={loading}
                            >
                                {loading ? 'Updating...' : 'Update Password'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export const Profile = () => {
    const data = useSelector((state) => state.auth);
    const mode = data ? 'edit' : 'create';
    console.log(data.user);
    return <EditViewForm initialData={data.user} mode={mode} />;
};
export default Profile;
